import React from "react";
import image4 from "../../assets/images/png/corporate-healthcare.png";

const INDUSTRY_CARDS = [
  {
    title: "Real Estate & Infra",
    img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop",
  },
  {
    title: "Professional Services",
    img: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=800&auto=format&fit=crop",
  },
  {
    title: "Manufacturing",
    img: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=800&auto=format&fit=crop",
  },
  {
    title: "Healthcare & Tech",
    img: image4,
  },
];
const MARQUEE_GROUPS = Array.from({ length: 3 });

const CorporateIndustries = () => {
  return (
    <section className="industries-wrapper py-5">
      <div className="container-fluid px-0">
        <h2 className="industries-title display-5 text-center mb-5">
          Industries Served
        </h2>

        <div className="marquee-container bottom-track mt-4">
          <div className="marquee-content scroll-right">
            {MARQUEE_GROUPS.map((_, groupIndex) => (
              <React.Fragment key={`img-group-${groupIndex}`}>
                {INDUSTRY_CARDS.map((card) => (
                  <div
                    key={`${groupIndex}-${card.title}`}
                    className="industry-image-card"
                  >
                    <img
                      loading="lazy"
                      decoding="async"
                      src={card.img}
                      alt={card.title}
                      className="img-fluid"
                    />
                    <div className="card-overlay">
                      <h4 className="card-title m-0">{card.title}</h4>
                    </div>
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateIndustries;
